export default {
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title': 'Characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.description':
    'View demographic characteristics of the cohort.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.notProcessedHeader': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.notProcessedDescription':
    'Process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.drawerTitle': 'Demographics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.columnLabel': 'Characteristic',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.valueLabel': 'N =',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ageAtIndexSection':
    'Age at index date, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.genderSection': 'Gender, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.raceSection': 'Race, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ethnicitySection':
    'Ethnicity, n (%)',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ageAtIndex': 'Age at index date',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.race': 'Race',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.gender': 'Gender',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ethnicity': 'Ethnicity',

  // no results - sections
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ageAtIndex':
    'No age at index date',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.race': 'No race',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.gender': 'No gender',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ethnicity': 'No ethnicity',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ageAtIndex':
    'Set an index date and re-process the cohort to view data for age at index.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.race':
    'Update cohort and re-process the cohort to view data for race.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.messge.empty.gender':
    'Update cohort and re-process the cohort to view data for gender.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ethnicity':
    'Update cohort and re-process the cohort to view data for ethnicity.',

  'projects.cohortBuilder.cohortCharacteristicsCharts.barChart.xAxisLabel': 'Age (years)',
  'projects.cohortBuilder.cohortCharacteristicsCharts.barChart.yAxisLabel': 'Count',
  'projects.cohortBuilder.cohortCharacteristicsCharts.barChart.seriesLabel': 'Age',

  // no data to display
  'projects.cohortBuilder.cohortCharacteristicsPageTab.noData.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.noData.message':
    'Process the cohort to view characteristics data for subjects who meet all cohort criteria.',

  // workflow message
  'projects.cohortBuilder.cohortCharacteristicsPageTab.draft.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.draft.message':
    'Process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processing.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processing.message':
    'Characteristics data for subjects who meet all cohort criteria will be available once cohort processing is complete.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.error.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.error.message':
    'Edit and re-process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processedNoData.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processedNoData.message':
    'Edit and re-process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.loading.title': 'Loading characteristics',
};
